// extracted by mini-css-extract-plugin
export default {"tabs":"BottomTabs_tabs__-Rlbv"};